import {Box} from '../Box';
import {Matm} from '../../../classes/Matm';

declare const THREE: any;

export class FloorUVGenerator {

  private vAxis = new THREE.Vector3(0, 0, 1);
  private uAxis = new THREE.Vector3(1, 0, 0);
  private readonly uvRange = {min: 0, max: 1};
  private topFacesNormal = new THREE.Vector3(0, 0, -1);

  generate(box: Box, floorMesh) {

    const geometry = floorMesh.geometry;

    const vertices = geometry.vertices;
    const uv = [];
    const vertex = new THREE.Vector3();
    const {length, height, min} = box;

    for (const face of geometry.faces) {
      const isTopFace = face.normal.dot(this.topFacesNormal) >= 0.99;
      let faceVertices = [vertices[face.a], vertices[face.b], vertices[face.c]];
      if (isTopFace) {
        faceVertices = faceVertices.map(vtx => {
          vertex.set(vtx.x, 0, vtx.y);
          const vertexToOrigin = vertex.sub(min);
          const v = vertexToOrigin.clone().projectOnVector(this.vAxis).length();
          const u = vertexToOrigin.clone().projectOnVector(this.uAxis).length();
          const mappedV = Matm.mapRange({min: 0, max: height, value: v}, this.uvRange);
          const mappedU = Matm.mapRange({min: 0, max: length, value: u}, this.uvRange);
          return new THREE.Vector2(mappedU, mappedV);
        });
      }
      uv.push(faceVertices);
    }

    return uv;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/lightMap/uvGenerator/FloorUVGenerator.ts